  (function() {
    const form = document.querySelector('[data-filters-form]');
    if (!form) return;

    const activePillsContainer = document.querySelector('[data-active-pills]');
    const pillsDivider = document.querySelector('[data-pills-divider]');
    const clearAllBtn = document.querySelector('[data-clear-all]');

    const FILTER_LABELS = {
      'sweet-dreams': 'Sweet Dreams',
      'dream-jobs': 'Dream Jobs',
      'fantasy-magic-worlds': 'Fantasy & Magic Worlds',
      'educational-stories': 'Educational Stories',
      'superheroes': 'Superheroes',
      'adventures-exploration': 'Adventures & Exploration',
      '0-3': '0-3',
      '4-7': '4-7',
      '8-12': '8-12',
      'for-boys': 'For Boys',
      'for-girls': 'For Girls'
    };

    function getCurrentFilterState() {
      const state = {
        themes: [],
        ages: [],
        genders: [],
        sort: null
      };

      form.querySelectorAll('input[name="themes"]:checked').forEach(input => {
        state.themes.push(input.value);
      });

      form.querySelectorAll('input[name="age"]:checked').forEach(input => {
        state.ages.push(input.value);
      });

      form.querySelectorAll('input[name="gender"]:checked').forEach(input => {
        state.genders.push(input.value);
      });

      const sortInput = form.querySelector('input[name="sort"]:checked');
      if (sortInput) {
        state.sort = sortInput.value;
      }

      return state;
    }

    function hasActiveFilters(state = getCurrentFilterState()) {
      return (
        state.themes.length > 0 ||
        state.ages.length > 0 ||
        state.genders.length > 0 ||
        Boolean(state.sort)
      );
    }

    function getAppliedFilterState() {
      const params = new URLSearchParams(window.location.search);
      const state = {
        themes: [],
        ages: [],
        genders: [],
        sort: null
      };

      const themesParam = params.get('themes');
      if (themesParam) {
        state.themes = themesParam.split(',').filter(Boolean);
      }

      const ageParam = params.get('age');
      if (ageParam) {
        state.ages = ageParam.split(',').filter(Boolean);
      }

      const genderParam = params.get('gender');
      if (genderParam) {
        state.genders = genderParam.split(',').filter(Boolean);
      }

      const sortParam = params.get('sort');
      if (sortParam) {
        state.sort = sortParam;
      }

      return state;
    }

    function arraysEqual(a, b) {
      if (a.length !== b.length) return false;
      const sortedA = [...a].sort();
      const sortedB = [...b].sort();
      return sortedA.every((val, index) => val === sortedB[index]);
    }

    function hasUnappliedChanges() {
      const current = getCurrentFilterState();
      const applied = getAppliedFilterState();

      return (
        !arraysEqual(current.themes, applied.themes) ||
        !arraysEqual(current.ages, applied.ages) ||
        !arraysEqual(current.genders, applied.genders) ||
        current.sort !== applied.sort
      );
    }

    function updateApplyButtonState() {
      const applyBtn = form.querySelector('.filters__apply-btn');
      if (!applyBtn) return;

      const statusSpan = applyBtn.querySelector('[data-filter-apply-status]');
      const hasChanges = hasUnappliedChanges();

      if (hasChanges) {
        applyBtn.setAttribute('data-has-changes', 'true');
        applyBtn.setAttribute('aria-pressed', 'true');
        if (statusSpan) {
          statusSpan.textContent = ' (changes pending)';
        }
      } else {
        applyBtn.removeAttribute('data-has-changes');
        applyBtn.setAttribute('aria-pressed', 'false');
        if (statusSpan) {
          statusSpan.textContent = '';
        }
      }
    }

    function updateClearAllState(state = getCurrentFilterState()) {
      if (!clearAllBtn) return;

      const isActive = hasActiveFilters(state);

      clearAllBtn.hidden = !isActive;
      clearAllBtn.disabled = !isActive;
      clearAllBtn.classList.toggle('is-disabled', !isActive);
      clearAllBtn.setAttribute('aria-disabled', isActive ? 'false' : 'true');
    }

    function updateEmptyState(visibleCount) {
      const emptyState = document.querySelector('[data-filter-empty-state]');
      if (!emptyState) return;

      const state = getCurrentFilterState();
      const hasActiveFilters =
        state.themes.length > 0 ||
        state.ages.length > 0 ||
        state.genders.length > 0;

      if (visibleCount === 0 && hasActiveFilters) {
        emptyState.hidden = false;
      } else {
        emptyState.hidden = true;
      }
    }

    function filterProducts() {
      const cards = document.querySelectorAll('[data-product-card]');
      const state = getCurrentFilterState();

      let visibleCount = 0;

      cards.forEach((card) => {
        const productThemes = (card.dataset.filterThemes || '')
          .split(' ')
          .map((value) => value.trim())
          .filter(Boolean);

        const productAge = card.dataset.filterAge || '';
        const productGenders = (card.dataset.filterGender || '')
          .split(' ')
          .map((value) => value.trim())
          .filter(Boolean);

        const matchesThemes =
          state.themes.length === 0 ||
          state.themes.some((theme) => productThemes.includes(theme));

        const matchesAge =
          state.ages.length === 0 ||
          state.ages.includes(productAge);

        const matchesGender =
          state.genders.length === 0 ||
          state.genders.some((gender) => productGenders.includes(gender));

        const isVisible =
          matchesThemes &&
          matchesAge &&
          matchesGender;

        card.hidden = !isVisible;
        card.classList.toggle('is-hidden-by-filters', !isVisible);

        if (isVisible) visibleCount += 1;
      });

      updateEmptyState(visibleCount);
    }

    function sortProducts() {
      const grid = document.querySelector('[data-products-grid]');
      if (!grid) return;

      const state = getCurrentFilterState();
      const cards = [...grid.querySelectorAll('[data-product-card]')];

      const sortedCards = cards.sort((a, b) => {
        const priceA = Number(a.dataset.filterPrice || 0);
        const priceB = Number(b.dataset.filterPrice || 0);

        if (state.sort === 'price-asc') {
          return priceA - priceB;
        }

        if (state.sort === 'price-desc') {
          return priceB - priceA;
        }

        const indexA = Number(a.dataset.originalIndex || 0);
        const indexB = Number(b.dataset.originalIndex || 0);
        return indexA - indexB;
      });

      sortedCards.forEach((card) => grid.appendChild(card));
    }

    function applyFiltersAndSort() {
      filterProducts();
      sortProducts();
    }

    function animateVisibleCards() {
      const cards = [...document.querySelectorAll('[data-product-card]')];
      const visibleCards = cards.filter((card) => !card.hidden);

      visibleCards.forEach((card, index) => {
        card.classList.remove('is-card-visible');
        card.classList.add('is-card-entering');
        card.style.transitionDelay = `${Math.min(index * 35, 210)}ms`;
      });

      requestAnimationFrame(() => {
        visibleCards.forEach((card) => {
          card.classList.remove('is-card-entering');
          card.classList.add('is-card-visible');
        });
      });

      window.setTimeout(() => {
        visibleCards.forEach((card) => {
          card.style.transitionDelay = '';
        });
      }, 500);
    }

    function scrollToResultsTop() {
      const section = document.querySelector('[data-collection-all]');
      if (!section) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      section.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    }

    function updateProductsWithTransition({ updateUrl = false, closeDrawer = false, scrollToTop = false } = {}) {
      const grid = document.querySelector('[data-products-grid]');
      if (!grid) {
        applyFiltersAndSort();
        if (updateUrl) writeStateToUrl();
        if (closeDrawer) closeFilterDrawer();
        if (scrollToTop) scrollToResultsTop();
        return;
      }

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion) {
        applyFiltersAndSort();
        if (updateUrl) writeStateToUrl();
        if (closeDrawer) closeFilterDrawer();
        if (scrollToTop) scrollToResultsTop();
        return;
      }

      grid.classList.add('is-updating');

      window.setTimeout(() => {
        applyFiltersAndSort();
        animateVisibleCards();

        requestAnimationFrame(() => {
          grid.classList.remove('is-updating');
        });

        if (updateUrl) writeStateToUrl();
        if (closeDrawer) closeFilterDrawer();
        if (scrollToTop) scrollToResultsTop();
      }, 190);
    }

    function renderActivePills() {
      const drawer = document.querySelector('[data-filter-drawer]');
      const previousScrollTop = drawer?.scrollTop ?? 0;

      const state = getCurrentFilterState();
      updateClearAllState(state);

      const pills = [];

      state.themes.forEach(theme => {
        const label = FILTER_LABELS[theme] || theme;
        pills.push({
          type: 'themes',
          value: theme,
          label: label
        });
      });

      state.ages.forEach(age => {
        pills.push({
          type: 'age',
          value: age,
          label: age
        });
      });

      state.genders.forEach(gender => {
        const label = FILTER_LABELS[gender] || gender;
        pills.push({
          type: 'gender',
          value: gender,
          label: label
        });
      });

      if (state.sort) {
        pills.push({
          type: 'sort',
          value: state.sort,
          label: state.sort === 'price-asc' ? 'Price: Low to High' : 'Price: High to Low'
        });
      }

      if (pills.length > 0) {
        activePillsContainer.innerHTML = '';
        pills.forEach(pill => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'filter-pill';
          button.dataset.filterType = pill.type;
          button.dataset.filterValue = pill.value;
          button.setAttribute('aria-label', `Remove ${pill.label} filter`);

          const textSpan = document.createElement('span');
          textSpan.className = 'filter-pill__text';
          textSpan.textContent = pill.label;

          const closeSpan = document.createElement('span');
          closeSpan.className = 'filter-pill__close';
          closeSpan.setAttribute('aria-hidden', 'true');
          closeSpan.textContent = '×';

          button.appendChild(textSpan);
          button.appendChild(closeSpan);
          activePillsContainer.appendChild(button);
        });
        pillsDivider.style.display = 'block';
      } else {
        activePillsContainer.innerHTML = '';
        pillsDivider.style.display = 'none';
      }

      activePillsContainer.querySelectorAll('.filter-pill').forEach(pill => {
        pill.addEventListener('click', handlePillRemove);
      });

      if (drawer) {
        drawer.scrollTop = previousScrollTop;
      }
    }

    function handlePillRemove(e) {
      const pill = e.currentTarget;
      const filterType = pill.getAttribute('data-filter-type');
      const filterValue = pill.getAttribute('data-filter-value');

      if (filterType === 'themes') {
        const checkbox = form.querySelector(`input[name="themes"][value="${filterValue}"]`);
        if (checkbox) {
          checkbox.checked = false;
        }
      } else if (filterType === 'age') {
        const checkbox = form.querySelector(`input[name="age"][value="${filterValue}"]`);
        if (checkbox) {
          checkbox.checked = false;
        }
      } else if (filterType === 'gender') {
        const checkbox = form.querySelector(`input[name="gender"][value="${filterValue}"]`);
        if (checkbox) {
          checkbox.checked = false;
        }
      } else if (filterType === 'sort') {
        const radio = form.querySelector(`input[name="sort"][value="${filterValue}"]`);
        if (radio) {
          radio.checked = false;
        }
      }

      renderActivePills();
      updateFilterCount();
      updateProductsWithTransition({
        updateUrl: true,
        closeDrawer: false
      });
    }

    function writeStateToUrl() {
      const state = getCurrentFilterState();
      const params = new URLSearchParams(window.location.search);
      const viewParam = params.get('view');

      const newParams = new URLSearchParams();
      if (viewParam) {
        newParams.set('view', viewParam);
      }

      if (state.themes.length > 0) {
        newParams.set('themes', state.themes.join(','));
      }
      if (state.ages.length > 0) {
        newParams.set('age', state.ages.join(','));
      }
      if (state.genders.length > 0) {
        newParams.set('gender', state.genders.join(','));
      }
      if (state.sort) {
        newParams.set('sort', state.sort);
      }

      const queryString = newParams.toString();
      const newUrl = queryString ? `/collections/all?${queryString}` : '/collections/all';
      window.history.replaceState({}, '', newUrl);
    }

    function handleClearAll(e) {
      e.preventDefault();

      if (e.currentTarget === clearAllBtn && clearAllBtn.disabled) {
        return;
      }

      form.querySelectorAll('input[type="checkbox"]').forEach(input => {
        input.checked = false;
      });
      form.querySelectorAll('input[type="radio"]').forEach(input => {
        input.checked = false;
      });

      renderActivePills();
      updateFilterCount();
      updateProductsWithTransition({
        updateUrl: false,
        closeDrawer: false
      });

      const params = new URLSearchParams(window.location.search);
      const viewParam = params.get('view');
      const newUrl = viewParam ? `/collections/all?view=${viewParam}` : '/collections/all';
      window.history.replaceState({}, '', newUrl);
    }

    function handleApplyFilters(e) {
      e.preventDefault();

      // Pills reflect applied filters, not the form's live checkbox state, so
      // they only appear/move here, not while someone is still ticking boxes.
      renderActivePills();

      updateProductsWithTransition({
        updateUrl: true,
        closeDrawer: true,
        scrollToTop: true
      });

      // After applying, the form state matches URL state, so reset button
      updateApplyButtonState();
    }

    function initializeFromUrl() {
      const params = new URLSearchParams(window.location.search);

      const themesParam = params.get('themes');
      if (themesParam) {
        const themes = themesParam.split(',');
        themes.forEach(theme => {
          const checkbox = form.querySelector(`input[name="themes"][value="${theme}"]`);
          if (checkbox) {
            checkbox.checked = true;
          }
        });
      }

      const ageParam = params.get('age');
      if (ageParam) {
        const ages = ageParam.split(',');
        ages.forEach(age => {
          const checkbox = form.querySelector(`input[name="age"][value="${age}"]`);
          if (checkbox) {
            checkbox.checked = true;
          }
        });
      }

      const genderParam = params.get('gender');
      if (genderParam) {
        const genders = genderParam.split(',');
        genders.forEach(gender => {
          const checkbox = form.querySelector(`input[name="gender"][value="${gender}"]`);
          if (checkbox) {
            checkbox.checked = true;
          }
        });
      }

      const sortParam = params.get('sort');
      if (sortParam) {
        const radio = form.querySelector(`input[name="sort"][value="${sortParam}"]`);
        if (radio) {
          radio.checked = true;
        }
      }

      renderActivePills();
      updateFilterCount();
      applyFiltersAndSort();
    }

    form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(input => {
      input.addEventListener('change', function() {
        // Ticking a box is not applying it: leave the active-pills row (and the
        // sidebar layout) alone here. updateApplyButtonState signals the pending
        // change instead; renderActivePills runs once Apply is actually clicked.
        updateFilterCount();
        updateApplyButtonState();
      });
    });

    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', handleClearAll);
    }

    const emptyClearBtn = document.querySelector('[data-empty-clear-all]');
    if (emptyClearBtn) {
      emptyClearBtn.addEventListener('click', handleClearAll);
    }

    form.addEventListener('submit', handleApplyFilters);

    const productCards = document.querySelectorAll('[data-product-card]');
    productCards.forEach((card, index) => {
      card.dataset.originalIndex = String(index);
    });

    document.querySelectorAll('[data-filter-toggle]').forEach(toggle => {
      toggle.addEventListener('click', function() {
        const group = this.closest('[data-filter-group]');
        const content = group.querySelector('[data-filter-content]');
        if (!group || !content) return;

        const isOpen = group.classList.contains('is-open');

        if (isOpen) {
          group.classList.remove('is-open');
          this.setAttribute('aria-expanded', 'false');
          content.hidden = true;
        } else {
          group.classList.add('is-open');
          this.setAttribute('aria-expanded', 'true');
          content.hidden = false;
        }
      });
    });

    const drawer = document.querySelector('[data-filter-drawer]');
    const drawerOverlay = document.querySelector('[data-filter-drawer-overlay]');
    const drawerOpenBtn = document.querySelector('[data-filter-drawer-open]');
    const drawerCloseBtn = document.querySelector('[data-filter-drawer-close]');
    const filterCountBadge = document.querySelector('[data-filter-count]');

    function updateFilterCount() {
      const state = getCurrentFilterState();
      const count = state.themes.length + state.ages.length + state.genders.length + (state.sort ? 1 : 0);

      if (filterCountBadge) {
        filterCountBadge.textContent = count;
        filterCountBadge.hidden = count === 0;
      }
    }

    function updateDrawerTopOffset() {
      const root = document.querySelector('[data-collection-all]');
      if (!root) return;

      if (!window.matchMedia('(max-width: 1023px)').matches) return;

      let offset = 0;

      const announcement =
        document.querySelector('.announcement-bar') ||
        document.querySelector('[class*="announcement"]') ||
        document.querySelector('.shopify-section-announcement-bar');

      if (announcement) {
        const rect = announcement.getBoundingClientRect();

        if (rect.bottom > 0) {
          offset = Math.round(rect.bottom);
        }
      }

      root.style.setProperty('--collection-drawer-top-offset', `${offset}px`);
    }

    function closeBurgerIfOpen() {
      if (!window.matchMedia('(max-width: 1023px)').matches) return;

      const burgerIsOpen = document.body.classList.contains('mobile-menu-open');
      if (!burgerIsOpen) return;

      const burgerTrigger = document.querySelector('.header__burger');
      if (burgerTrigger && burgerTrigger.getAttribute('aria-expanded') === 'true') {
        burgerTrigger.click();
      }
    }

    function disableBurgerWhileFiltersOpen() {
      if (!window.matchMedia('(max-width: 1023px)').matches) return;

      const burgerTrigger = document.querySelector('.header__burger');
      if (!burgerTrigger) return;

      burgerTrigger.setAttribute('aria-disabled', 'true');
      burgerTrigger.setAttribute('data-disabled-by-filters', 'true');

      if (burgerTrigger instanceof HTMLButtonElement) {
        burgerTrigger.disabled = true;
      }
    }

    function enableBurgerAfterFiltersClose() {
      if (!window.matchMedia('(max-width: 1023px)').matches) return;

      const burgerTrigger = document.querySelector('.header__burger');
      if (!burgerTrigger) return;

      burgerTrigger.removeAttribute('aria-disabled');
      burgerTrigger.removeAttribute('data-disabled-by-filters');

      if (burgerTrigger instanceof HTMLButtonElement) {
        burgerTrigger.disabled = false;
      }
    }

    let collectionScrollY = 0;

    function lockCollectionScroll() {
      if (!window.matchMedia('(max-width: 1023px)').matches) return;

      collectionScrollY = window.scrollY || window.pageYOffset || 0;

      document.documentElement.classList.add('collection-filters-open');
      document.body.classList.add('collection-filters-open');

      document.body.style.position = 'fixed';
      document.body.style.top = `-${collectionScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockCollectionScroll() {
      if (!window.matchMedia('(max-width: 1023px)').matches) return;

      document.documentElement.classList.remove('collection-filters-open');
      document.body.classList.remove('collection-filters-open');

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';

      window.scrollTo(0, collectionScrollY);
    }

    function openFilterDrawer() {
      if (!drawer || !drawerOverlay) return;

      closeBurgerIfOpen();

      updateDrawerTopOffset();

      const root = document.querySelector('[data-collection-all]');
      if (root) {
        root.classList.add('is-filters-open');
      }

      drawer.classList.add('is-open');
      drawerOverlay.removeAttribute('hidden');
      drawerOverlay.classList.add('is-open');

      lockCollectionScroll();
      disableBurgerWhileFiltersOpen();

      if (drawerOpenBtn) {
        drawerOpenBtn.setAttribute('aria-expanded', 'true');
      }

      if (drawerCloseBtn) {
        setTimeout(() => drawerCloseBtn.focus(), 100);
      }
    }

    function closeFilterDrawer() {
      if (!drawer || !drawerOverlay) return;

      const root = document.querySelector('[data-collection-all]');
      if (root) {
        root.classList.remove('is-filters-open');
      }

      drawer.classList.remove('is-open');
      drawerOverlay.classList.remove('is-open');

      unlockCollectionScroll();
      enableBurgerAfterFiltersClose();

      setTimeout(() => {
        if (!drawer.classList.contains('is-open')) {
          drawerOverlay.setAttribute('hidden', '');
        }
      }, 250);

      if (drawerOpenBtn) {
        drawerOpenBtn.setAttribute('aria-expanded', 'false');
        drawerOpenBtn.focus();
      }
    }

    if (drawerOpenBtn) {
      drawerOpenBtn.addEventListener('click', openFilterDrawer);
    }

    if (drawerCloseBtn) {
      drawerCloseBtn.addEventListener('click', closeFilterDrawer);
    }

    if (drawerOverlay) {
      drawerOverlay.addEventListener('click', closeFilterDrawer);
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
        closeFilterDrawer();
      }
    });

    updateDrawerTopOffset();
    window.addEventListener('resize', updateDrawerTopOffset);
    window.addEventListener('orientationchange', updateDrawerTopOffset);

    initializeFromUrl();
    updateApplyButtonState();
  })();
